module.exports = __webpack_public_path__ + "static/media/gallery-25.649f1a54.jpg";